import { environment } from 'src/environments/environment';
import { normalize } from '@/utils/normalizeString';
import { appUrisArr } from 'app.environment';

export function getEnvironment(): typeof environment {
  if (!environment.production) {
    return environment;
  }

  const customEnvironment = environment;
  if (window) {
    const uriConfig = appUrisArr.find((appUri) => {
      const key = appUri.frontUri.replace('https://', '').replace('http://', '').replace('/', '');
      return normalize(window.location.href).slice(0, 70).includes(normalize(key));
    });
    if (uriConfig) {
      customEnvironment.appUri = uriConfig.frontUri;
      customEnvironment.baseUrl = uriConfig.bffUri;
      customEnvironment.production = true;
      customEnvironment.disableAzureLogin = false;
      customEnvironment.azureTenant = uriConfig.azureTenant;
      customEnvironment.azureScopes = uriConfig.azureScopes;
      customEnvironment.azureClientId = uriConfig.azureClientId;    }
  }
  return customEnvironment;
}
